export class FormulaCatalogoPersonalizacaoRequest {
    chaveFormula: string;
    chaveFormulaModelo: string | null = null;
    expressaoPersonalizada: string | null = null;
}
